import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (iso) =>
  iso ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";

export default function AdminAudit() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    document.title = "Audit Log | Rooted Healing Admin";
    api.get("/admin/audit").then(({ data }) => setEntries(data.entries));
  }, []);

  return (
    <div data-testid="admin-audit">
      <h1 className="font-serif text-3xl text-forest">Audit Log</h1>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-taupe">
        Every sensitive administrative view, export, content edit, and deletion is recorded
        here with the administrator and timestamp.
      </p>
      {!entries ? (
        <Loader2 className="mt-10 h-7 w-7 animate-spin text-forest" />
      ) : (
        <div className="mt-6 overflow-x-auto rounded-[1.75rem] border border-forest/10 bg-white/75">
          <table className="w-full min-w-[560px] text-left text-sm">
            <thead>
              <tr className="border-b border-forest/10 text-xs uppercase tracking-[0.15em] text-taupe">
                <th className="px-5 py-4">When</th>
                <th className="px-5 py-4">Administrator</th>
                <th className="px-5 py-4">Action</th>
                <th className="px-5 py-4">Subject</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e, i) => (
                <tr key={i} className="border-b border-forest/5">
                  <td className="px-5 py-3.5 text-charcoal/75">{fmt(e.at)}</td>
                  <td className="px-5 py-3.5 text-charcoal/75">{e.admin_email}</td>
                  <td className="px-5 py-3.5 font-semibold text-forest">{e.action}</td>
                  <td className="px-5 py-3.5 text-charcoal/60">{e.target || "—"}</td>
                </tr>
              ))}
              {entries.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-5 py-10 text-center text-taupe">
                    No administrative activity recorded yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
